export const defaultMessages = {
    required: 'This field is required (cannot be left empty)',
    invalidEmail: 'Invalid email address provided',
    invalidTel: 'Invalid telephone number provided',
};
